import { DesktopContainer } from './DesktopContainer'
import MobileContainer from './MobileContainer'
import { useScreenSize } from '../../hooks/screen-size'

export const SectionContainer = ({ className, color, secondary, title, items, children, handleMobileModal, section, setLock, scrollRight }) => {
  const { isDesktop } = useScreenSize()

  return isDesktop ? (
    <DesktopContainer className={className} color={color} secondary={secondary} title={title} items={items} setLock={setLock}>
      {children}
    </DesktopContainer>
  ) : (
    <MobileContainer
      className={className}
      section={section}
      color={color}
      secondary={secondary}
      title={title}
      items={items}
      setLock={setLock}
      onClick={handleMobileModal}
      scrollRight={scrollRight}
    >
      {children}
    </MobileContainer>
  )
}
